import { useTranslation } from 'react-i18next';

const WizardStepItemDone: React.FC<WizardStepItemDoneProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div>
            <s-text>{props.message}</s-text>
            <div className="pt-1 flex items-center gap-2">
                {props.action}
                <s-badge tone="neutral" icon="check">
                    {t('WIZARD.SETUP_COMPLETE')}
                </s-badge>
            </div>
        </div>
    );
};

interface WizardStepItemDoneProps {
    message: string;
    action: React.ReactNode;
}

export default WizardStepItemDone;
